<template>
  <div>
    <div>
      <span v-html="$t('new-event.images.description-one')" /> (<a
        href="#"
        @click="
          openExample(
            banner,
            $t('new-event.images.examples.banner-title'),
            $t('new-event.images.examples.banner-subtitle'),
            'justify-start'
          )
        "
        >{{ $t("new-event.images.examples.title") }}</a
      >) <span v-html="$t('new-event.images.description-two')" /> (<a
        href="#"
        @click="
          openExample(
            catalog,
            $t('new-event.images.examples.catalog-title'),
            $t('new-event.images.examples.catalog-subtitle'),
            'justify-center'
          )
        "
        >{{ $t("new-event.images.examples.title") }}</a
      >) <span v-html="$t('new-event.images.description-three')" /> (<a
        href="#"
        @click="
          openExample(
            mapEvent,
            $t('new-event.images.examples.map-event-title'),
            $t('new-event.images.examples.map-event-subtitle'),
            'justify-end mb-16'
          )
        "
        >{{ $t("new-event.images.examples.title") }}</a
      >).
    </div>
    <v-card-subtitle v-if="!imageLimit">
      <v-chip-group
        mandatory
        active-class="primary--text"
        v-model="typeImageSelected"
      >
        <v-chip
          small
          :disabled="hasEmphasisImage"
          filter
          outlined
          value="destaque"
          color="tertiary"
        >
          {{ $t("new-event.images.banner") }}*
        </v-chip>
        <v-chip
          small
          filter
          outlined
          :disabled="hasCardImage"
          value="imagem1"
          color="tertiary"
          >{{ $t("new-event.images.catalog") }}*
        </v-chip>
        <v-chip
          small
          filter
          outlined
          :disabled="hasMapImage"
          value="map"
          color="tertiary"
          >{{ $t("new-event.images.map") }}
        </v-chip>
      </v-chip-group>
    </v-card-subtitle>
    <v-card-text>
      <div
        class="image-uploader rounded-lg"
        @dragover.prevent
        @drop="handleDrop"
        @dragleave="enterHover = false"
        @dragover="enterHover = true"
        :class="{ 'drag-hover': enterHover }"
        @click="openFileInput"
        v-if="!imageLimit"
      >
        <div v-if="getEventImagesLoading">
          <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="primary"
          >
          </v-progress-circular>
        </div>
        <div v-else>
          <input
            type="file"
            ref="fileInput"
            style="display: none"
            @change="handleFileInput"
          />
          <v-icon class="upload-icon"> mdi-cloud-upload </v-icon>
          <div class="upload-text">
            <p>{{ $t("new-event.images.drop-image") }}</p>
            <p>{{ $t("new-event.images.upload-image") }}</p>
          </div>
        </div>
        <span class="image-quantity"> {{ getEventImages.length }}/3 </span>
      </div>

      <ul class="grey--text body-2 mt-2">
        <li>
          {{ $t("new-event.images.image-banner") }}
          <span class="font-weight-bold"> 1920x672px</span>
        </li>
        <li>
          {{ $t("new-event.images.image-catalog") }}
          <span class="font-weight-bold"> 1080x1920px</span>
        </li>
        <li>
          {{ $t("new-event.images.image-map") }}
          <span class="font-weight-bold"> 1024x768px</span>
        </li>
        <li>{{ $t("new-event.images.format") }}</li>
      </ul>
      <small class="grey--text">
        {{ $t("new-event.images.info-preview") }}</small
      >
      <div class="d-flex flex-wrap">
        <div
          class="image-preview mt-5 rounded-lg mr-5"
          v-for="(image, index) in getEventImages"
          :key="index"
        >
          <template v-if="image.type !== 'imagem2'">
            <v-img
              :src="image.url"
              :lazy-src="image.url"
              class="responsive-img rounded-t-lg rounded-b-lg"
            />
            <div class="my-1" v-html="cardText(image.type)" />
            <v-btn
              fab
              color="red"
              size="x-small"
              class="remove-img-btn red--bg white--text"
              @click="confirmRemove(image)"
            >
              <v-icon dark size="18">mdi-delete-outline</v-icon>
            </v-btn>
          </template>
        </div>
      </div>
    </v-card-text>
    <ImageExample
      :dialog.sync="dialog"
      @close="closeExample"
      :image="image"
      :title="title"
      :subtitle="subtitle"
      :orientation="orientation"
    />

    <ConfirmAction
      :dialog.sync="confirmDelete"
      :title="$t('new-event.images.remove')"
      :subtitle="$t('new-event.images.remove-description')"
      @action="removeImage"
      @close="cancelRemove"
    />
  </div>
</template>

<script>
import mixins from "@/mixins";
import { mapGetters, mapActions, mapMutations } from "vuex";
import ImageExample from "./EventSettingsModal/ImageExample.vue";
import banner from "../../assets/exampleEvent/banner.png";
import catalog from "../../assets/exampleEvent/catalog.png";
import mapEvent from "../../assets/exampleEvent/mapEvent.png";
import ConfirmAction from "./EventSettingsModal/ConfirmAction.vue";

const { products } = mixins;
export default {
  name: "EventImages",
  mixins: [products],
  data() {
    return {
      banner,
      catalog,
      mapEvent,
      imagePreview: [],
      fileInput: null,
      enterHover: false,

      dialog: false,
      image: "",
      title: "",
      subtitle: "",
      orientation: "",

      confirmDelete: false,
      imageToDelete: null,
    };
  },
  components: {
    ImageExample,
    ConfirmAction,
  },
  computed: {
    ...mapGetters([
      "getEventImages",
      "getIdEvent",
      "storeSequencial",
      "getEventImagesLoading",
      "getTypeImageSelected",
      "getSlug",
    ]),
    imageLimit() {
      return this.getEventImages.length >= 4;
    },
    hasCardImage() {
      return this.getEventImages.some(image => image.type === "imagem1");
    },
    hasEmphasisImage() {
      return this.getEventImages.some(image => image.type === "destaque");
    },
    hasMapImage() {
      return this.getEventImages.some(image => image.type === "map");
    },
    typeImageSelected: {
      get() {
        return this.getTypeImageSelected;
      },
      set(value) {
        this.setTypeImageSelected(value);
      },
    },
  },
  methods: {
    ...mapActions(["uploadNewEventImage", "showSnackbarSuccess"]),
    ...mapMutations(["setTypeImageSelected"]),
    openExample(image, title, subtitle, orientation) {
      this.dialog = true;
      this.image = image;
      this.title = title;
      this.subtitle = subtitle;
      this.orientation = orientation;
    },
    closeExample() {
      this.dialog = false;
      this.image = "";
      this.title = "";
      this.subtitle = "";
      this.orientation = "";
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = event => {
          resolve(event.target.result);
        };
        reader.onerror = error => {
          reject(error);
        };
        reader.readAsDataURL(file);
      });
    },
    async uploadImage(file) {
      this.enterHover = false;
      if (file) {
        try {
          const base64Image = await this.fileToBase64(file);
          await this.uploadNewEventImage({
            file: base64Image,
            store: this.storeSequencial,
            product: this.getIdEvent,
            image: this.getTypeImageSelected,
            slug: this.getSlug,
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
    handleFileInput(event) {
      const target = event.target;
      if (target.files) {
        this.handleFiles(target.files);
      }
      this.uploadImage(target.files[0]);
    },
    handleDrop(event) {
      event.preventDefault();
      if (event.dataTransfer?.files) {
        this.handleFiles(event.dataTransfer.files);
        this.uploadImage(event.dataTransfer.files[0]);
      }
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFiles(files) {
      Array.from(files).forEach(file => {
        const reader = new FileReader();
        reader.onload = e => {
          if (e.target?.result) {
            this.imagePreview.push({
              image: e.target.result,
              type: this.getTypeImageSelected,
            });
          }
        };
        reader.readAsDataURL(file);
      });
    },
    cardText(type) {
      if (type === "imagem1") {
        return this.$t("new-event.images.catalog-desc");
      } else if (type === "destaque") {
        return this.$t("new-event.images.banner-desc");
      } else {
        return this.$t("new-event.images.map-desc");
      }
    },
    confirmRemove(image) {
      this.confirmDelete = true;
      this.imageToDelete = image;
    },
    cancelRemove() {
      this.confirmDelete = false;
      this.imageToDelete = null;
    },
    removeImage() {
      this.showSnackbarSuccess(this.$t("new-event.images.remove-success"));
      if (this.imageToDelete.type === "imagem1") {
        const imagem1Index = this.getEventImages.findIndex(
          img => img.type === "imagem1"
        );
        if (imagem1Index !== -1) this.getEventImages.splice(imagem1Index, 1);
        const imagem2Index = this.getEventImages.findIndex(
          img => img.type === "imagem2"
        );
        if (imagem2Index !== -1) this.getEventImages.splice(imagem2Index, 1);
      } else {
        const index = this.getEventImages.findIndex(
          img =>
            img.url === this.imageToDelete.url &&
            img.type === this.imageToDelete.type
        );
        if (index !== -1) this.getEventImages.splice(index, 1);
      }
      this.confirmDelete = false;
      this.imageToDelete = null;
    },
    changeType() {
      if (this.hasMapImage && !this.hasEmphasisImage && !this.hasCardImage) {
        this.setTypeImageSelected("imagem1");
      } else if (this.hasEmphasisImage && !this.hasCardImage) {
        this.setTypeImageSelected("imagem1");
      } else if (this.hasCardImage && !this.hasEmphasisImage) {
        this.setTypeImageSelected("destaque");
      } else if (this.hasEmphasisImage && this.hasCardImage) {
        this.setTypeImageSelected("map");
      }
    },
  },
  watch: {
    getEventImages() {
      this.changeType();
    },
  },
};
</script>

<style scoped>
.image-uploader {
  position: relative;
  border: 2px dashed #ccc;
  padding: 15px;
  text-align: center;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: #f7f7fa;
}

.upload-text {
  margin-top: 10px;
}

.drag-hover {
  border: 2px dashed var(--v-tertiary-base);
  background-color: var(--v-base-base);
  transition: all 0.2s ease-in-out;
}

.remove-img-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 30px;
  height: 30px;
  z-index: 10;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}
.image-preview {
  position: relative;
  border-radius: 12px;
  box-shadow: 2px 2px 4px #d9d9d9, -2px -2px 4px #ffffff;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  margin-bottom: 20px;
  text-align: center;
  height: min-content;
}

.responsive-img {
  width: 100%;
  max-width: 300px;
}

@media (max-width: 600px) {
  .image-preview {
    width: 100%;
    max-width: 300px;
  }
}
.image-preview:hover {
  transform: scale(1.07);
}

.image-quantity {
  position: absolute;
  top: -0.1rem;
  right: -0.1rem;
  display: grid;
  place-items: center;
  background-color: var(--v-tertiary-base);
  color: #ffffff;
  padding: 0.25rem 0.55rem;
  border-radius: 0 12px 0 50px;
}
</style>
